import { useState, useEffect } from "react";
import { DetailsTab } from "../Pages/MainPages/Products/panels/DetailsTab";
import { PricesTab } from "../Pages/MainPages/Products/panels/PricesTab";
import { OffersTab } from "../Pages/MainPages/Products/panels/OffersTab";

const TABS = [
  { key: "details", label: "Details" },
  { key: "prices", label: "Store Prices" },
  { key: "offers", label: "Offers" },
];

export const VariantEditPanel = ({ rowData, onSave, onCancel }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [form, setForm] = useState(rowData || {});

  useEffect(() => {
    setForm(rowData || {});
  }, [rowData]);

  const updateField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="border-t-2 border-pink-600 bg-gray-50/70 px-6 py-5">
      <div className="flex items-center gap-1 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={`relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors ${
              activeTab === tab.key
                ? "text-pink-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
            {tab.key === "prices" && form?.storePricing?.length > 0 && (
              <span className="rounded-full bg-pink-600 px-1.5 py-0.5 text-[10px] font-semibold text-white">
                {form.storePricing.length}
              </span>
            )}
            {tab.key === "offers" && form?.offers?.length > 0 && (
              <span className="rounded-full bg-pink-600 px-1.5 py-0.5 text-[10px] font-semibold text-white">
                {form.offers.length}
              </span>
            )}
            {activeTab === tab.key && (
              <span className="absolute -bottom-px left-0 right-0 h-0.5 bg-pink-600" />
            )}
          </button>
        ))}
        <button
          type="button"
          onClick={onCancel}
          title="Close"
          className="ml-auto flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700"
        >
          <i className="fa fa-times"></i>
        </button>
      </div>

      <div className="pt-5">
        {activeTab === "details" && <DetailsTab form={form} updateField={updateField} />}
        {activeTab === "prices" && <PricesTab form={form} updateField={updateField} />}
        {activeTab === "offers" && <OffersTab form={form} updateField={updateField} />}
      </div>

      <div className="mt-6 flex justify-end gap-3 border-t border-gray-200 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg border border-gray-300 bg-white px-5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={() => onSave(form)}
          className="rounded-lg bg-pink-600 px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-700"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};